import { personOf } from '../lib/person'

/** An avatar with initials and the short name; the full identity is the tooltip. */
export function Person({ who, avatarOnly, title }: {
  who: string | null | undefined
  avatarOnly?: boolean
  /** what the tooltip says instead of the bare identity — "taken · 17.09 16:02" */
  title?: string
}) {
  const p = personOf(who)
  return (
    <span className="person" title={title ?? who ?? undefined}>
      <span className={`avatar${p.person ? '' : ' is-service'}`} aria-hidden
            style={{ ['--hue' as string]: String(p.hue) }}>{p.initials}</span>
      {!avatarOnly && <span className="person-name">{p.name}</span>}
      {p.via && <span className="person-via" aria-label={`+ ${p.via}`}>+ {p.via}</span>}
    </span>
  )
}
